import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.Schadenmeldung.SchadenmeldungKostenPosition
 * Kosten für die einzelnen Positionen
 * Endpoints: /api/schadenmeldungen/schadenkosten
 */
export class SchadenmeldungKostenPositionApi extends BaseApiModel {
	constructor(initialProperties?: Partial<SchadenmeldungKostenPositionApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected code: string;
	/**
	 * Description: Währungscode für die Position
	 * APIL Type: string
	 */
	get Code(): string {
		return this.code;
	}

	/**
	 * Description: Währungscode für die Position
	 * APIL Type: string
	 */
	set Code(value: string) {
		this.code = value;
	}

	protected betrag: number;
	/**
	 * Description: Rechnungsbetrag der Position
	 * APIL Type: double
	 */
	get Betrag(): number {
		return this.betrag;
	}

	/**
	 * Description: Rechnungsbetrag der Position
	 * APIL Type: double
	 */
	set Betrag(value: number) {
		this.betrag = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): SchadenmeldungKostenPositionApi {
		return AppUtils.Helper.createFromMap(dataObject, SchadenmeldungKostenPositionApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Code = this.code;
		result.Betrag = this.betrag;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}